import { trackEditCandidateDetailsClickedEvent } from '../../../utils/events/addCandidateEvents';
import FormStep from './FormStep';
import { Stack, TextField } from 'braid-design-system';
import { ADD_CANDIDATE_FORM_FIELD_NAMES } from './AddCandidateForm';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';

interface Props {
  firstName: any;
  lastName: any;
  phone: any;
  editable: boolean;
}

const StepTwo = ({ firstName, lastName, phone, editable }: Props) => {
  const { t } = useTranslations(translations);
  const displayValues = [
    { value: `${firstName.value} ${lastName.value}` },
    { value: phone.value },
  ];
  return (
    <FormStep
      editable={editable}
      displayValues={displayValues}
      onEditClickTracking={trackEditCandidateDetailsClickedEvent}
    >
      <Stack space="medium">
        <TextField
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.FIRST_NAME}
          label={t('First name')}
          value={firstName.value}
          tone={firstName.valid ? 'neutral' : 'critical'}
          onChange={firstName.onChange}
          onBlur={firstName.onBlur}
          message={!firstName.valid && firstName.errorMessage}
          autoFocus
          reserveMessageSpace
          placeholder={t('Enter first name')}
        />

        <TextField
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.LAST_NAME}
          label={t('Last name')}
          value={lastName.value}
          tone={lastName.valid ? 'neutral' : 'critical'}
          onChange={lastName.onChange}
          onBlur={lastName.onBlur}
          message={!lastName.valid && lastName.errorMessage}
          reserveMessageSpace
          placeholder={t('Enter last name')}
        />

        <TextField
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.PHONE}
          label={t('Phone')}
          value={phone.value}
          tone={phone.valid ? 'neutral' : 'critical'}
          onChange={phone.onChange}
          onBlur={phone.onBlur}
          message={!phone.valid && phone.errorMessage}
          reserveMessageSpace
          placeholder={t('Enter phone number')}
        />
      </Stack>
    </FormStep>
  );
};

export default StepTwo;
